module.exports = __webpack_public_path__ + "static/media/FoodMenuIconProcess.e7f547de.jpg";